import { Injectable } from '@angular/core';
import { SiteService, SitesMap } from 'app/core/sites/site.service';
import { UserService } from 'app/core/user/user.service';
// import { SiteService } from 'app/core/sites/site.service';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';

export interface FilterParams {
    site?: string[];
    cfms_site?: string[];
    from?: any;
    to?: any;
    plate?: any;
}

@Injectable({
    providedIn: 'root',
})
export class FiltersService {
    /**
     * Objects
     */
    // check whether user is logged out so that new calls to backend are being sent

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    // private _httpParameters: HttpParams;
    private _filter: BehaviorSubject<FilterParams>;
    // In order to display the filters that are in use by the component AND WE NEED TO INITIALIZE IT
    private _inUseFilters: BehaviorSubject<{
        site: boolean;
        from: boolean;
        to: boolean;
    }> = new BehaviorSubject({ site: true, from: true, to: true });
    siteList: SitesMap[] = [];
    private lastFilter: FilterParams;
    initialSite: SitesMap[];

    /**
     * Constructor
     * @param _siteService
     */InventoryComponent
    constructor(
        private _siteService: SiteService,
        private _userService: UserService
    ) {
        // Initialize inUserFilter by component
        // this._inUseFilters.next({site: true, from: true, to: true});
        // Initialize object
        // console.log('[Filters Service] constructor')

        const finaleDateNow = new Date();
        // Get profile page if it exists
        // this.getSites();

        this.getUserFilters();

        this.lastFilter = {
            site: undefined,
            cfms_site: undefined,
            from: undefined,
            to: undefined,
        };
        // this._filter = new BehaviorSubject(this.modifyFilter(this.lastFilter));
        this._filter = new BehaviorSubject(this.lastFilter);

        // also update the lastFilter to initialize it
    }

    // -------------------------------------------------------------------------------------------------------
    // @ Accessors
    // -------------------------------------------------------------------------------------------------------

    /**
     * Getter for filtering options
     */
    get filter$(): Observable<FilterParams> {
        return this._filter.asObservable();
    }
    /**
     * Getter for active filters that apply on current component
     */
    get inUseFilters$(): Observable<{
        site: boolean;
        from: boolean;
        to: boolean;
    }> {
        return this._inUseFilters.asObservable();
    }

    // -------------------------------------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------------------------------------

    updateFilter(updtFilter: FilterParams) {
        console.log('Updating filters:', updtFilter);
        this.lastFilter = updtFilter;
        this._filter.next(Object.assign({}, updtFilter));
    }

    getHttpParams() {
        return this.lastFilter;
    }

    updateInUseFilters(site: boolean, from: boolean, to: boolean) {
        this._inUseFilters.next(
            Object.assign({}, { site: site, from: from, to: to })
        );
    }

    // -------------------------------------------------------------------------------------------------------
    // Private Methods
    // -------------------------------------------------------------------------------------------------------

    // private getSites(): void {
    //   this._siteService.sites$
    //   .pipe(takeUntil(this._unsubscribeAll))
    //   .subscribe({
    //     next: (response: string[]) => {
    //       this.siteList = response;
    //     },
    //     error: er => {
    //       console.log(er);
    //     }
    //   });
    // }

    // private modifyFilter(data: FilterParams): FilterParams {
    //   let siteString: string;
    //   if (typeof data.site == 'string') {
    //     siteString = data.site;
    //   } else if (data.site && data.site.length == 1) {
    //     siteString = data.site[0];
    //   } else if ( data.site && typeof data.site != "string" ) {
    //     siteString = data.site.join(';');
    //   }
    //   data.site = siteString ? siteString.split(';'): undefined;

    //   return data;
    // }

    getUserFilters(): void {
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (response: any) => {
                    // console.log('[Filter Service] get User Filters: ', response)
                    //if user is no Admin, initialize filter with the available siteList
                    if (!response || !response.roles) {
                        console.error('Invalid user response:', response);
                        return;
                    }
                    let userRoles = response.roles;

                    if (
                        userRoles?.includes('ROLE_ADMIN') ||
                        userRoles?.includes('ROLE_GENERAL_MANAGER')
                    ) {
                        this.siteList = undefined;
                    } else {
                        this.siteList = response.sites_delimited;
                    }
                },
                error: (er) => {
                    console.log(er);
                },
            });
    }

    unSubscribe() {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
